import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import logo from "../assets/images/bulllogo.png";

const useStyles = makeStyles({
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 20,
    textAlign: 'center',
  },
  logo: {
    maxWidth: 180,
    height: 'auto',
    display: 'block',
    margin: '0 auto',
  },
  link: {
    color: '#61dafb',
  },
});

const Header: React.FC = () => {
  const classes = useStyles();

  return (
    <header className={classes.header}>
      <img src={logo} className={classes.logo} alt="logo" width={64}/>
      <Typography variant='h4'>IQmulator</Typography>
    </header>
  );
};

export default Header;
